module.exports = __webpack_public_path__ + "static/img/6489_phase_function_Paper_Points.1f4ecae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6489_phase_function_Paper_Points.png
// module id = XxRf
// module chunks = 0